
export function getURLParameter(sParam){

    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&')
    for (let i = 0; i < sURLVariables.length; i++) {
        const sParameterName = sURLVariables[i].split('=')
        if (sParameterName[0] == sParam) {
            return sParameterName[1]
        }
    }
}

export function isMobileDevice() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
}


// WEBPACK FOOTER //
// ./src/js/utils.js